export default __webpack_public_path__ + "static/mars-close-2-39745d36ce4b92abfaa146f6dce57dbc.webp";